/**
 * Created by tigran on 19.01.25
 **/

import React, { FC } from 'react';
import { IconType } from '@svg/index';
import { DEFAULT_ICON_PROPS } from '@svg/helpers';

export const InputCalendarIcon: FC<IconType> = (props) => {
  const { width, height, color } = {
    ...DEFAULT_ICON_PROPS,
    ...props,
  };
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.3276 3.91936V2.20508"
        stroke={color}
        strokeWidth="1.37143"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M5.61377 3.91936V2.20508"
        stroke={color}
        strokeWidth="1.37143"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
      <path
        d="M2.18506 6.20508L14.7565 6.20508"
        stroke={color}
        strokeWidth="1.37143"
        strokeMiterlimit={10}
      />
      <path
        d="M14.7565 3.91992L2.18506 3.91992L2.18506 14.2056L14.7565 14.2056L14.7565 3.91992Z"
        stroke={color}
        strokeWidth="1.37143"
        strokeMiterlimit={10}
        strokeLinecap="square"
      />
    </svg>
  );
};
